// Module
var code = `<template> <div class="row justify-content-end"> <custom-button class="padding-5 primary" click.trigger="changeStatus()">Change Status</custom-button> </div> </template>`;
// Exports
module.exports = code;